import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePostRequest } from '../../service/PostTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';

const AddEditUser = ({ editable, viewable, onHide, rowRecord, onClose }) => {
    const [roleOptions, setRoleOptions] = useState([]);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Name must contain only alphanumeric values'),
        phone: Yup.string()
            .matches(/^\d+$/, 'Phone number should only contain numbers')
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),
        email: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .email('Invalid email')
            .required('This field is required'),
        roleId: Yup.mixed().required('Role is required')
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            id: '',
            name: '',
            email: '',
            phone: '',
            status: '',
            roleId: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

            setLoadingBtn(true);
            const addData = {
                name: data.name,
                email: data.email,
                phone: data.phone,
                roleId: data.roleId,
                createdBy: user?.data?.userId
            };

            const editData = {
                id: data.id,
                name: data.name,
                email: data.email,
                phone: data.phone,
                status: data.status,
                roleId: data.roleId,
                modifiedBy: user?.data?.userId
            };

            if (!editable) {
                const response = await dispatch(handlePostRequest(addData, endPoints.addUser, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            } else {
                const response = await dispatch(handlePutRequest(editData, endPoints.updateUser, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            }
        }
    });

    const getRoleOptions = async () => {
        const response = await handleGetRequest(endPoints.getDropdownRoles, true);
        setRoleOptions(response?.data);
    };
    useEffect(() => {
        getRoleOptions();
    }, []);

    const getUserById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getUserById(rowRecord.id), true);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('name', response?.data?.name);
            formik.setFieldValue('email', response?.data?.email);
            formik.setFieldValue('phone', response?.data?.phone);
            formik.setFieldValue('status', response?.data?.status);
            formik.setFieldValue('roleId', response?.data?.roleId);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        if (editable || viewable) {
            getUserById();
        }
    }, [rowRecord]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="name">
                            Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="name" name="name" placeholder="Enter Name" value={formik?.values?.name} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="email">
                            Email <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="email" name="email" placeholder="Enter Email" value={formik?.values?.email} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.email && formik.errors.email && <small className="p-error">{formik.errors.email}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="phone">
                            Phone <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="phone" name="phone" placeholder="Enter Phone" value={formik?.values?.phone} maxLength={11} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.phone && formik.errors.phone && <small className="p-error">{formik.errors.phone}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="roleId">
                            Role <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown id="roleId" name="roleId" value={formik?.values?.roleId} options={roleOptions} optionLabel="name" optionValue="id" onChange={formik.handleChange} placeholder="Select Role" className="w-full" disabled={viewable} />
                        {formik.touched.roleId && formik.errors.roleId && <small className="p-error">{formik.errors.roleId}</small>}
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
            </div>
        </form>
    );
};

export default AddEditUser;
